/*
 * @Author: cc
 * @Date: 2020-03-31 16:16:47
 * @LastEditTime: 2021-05-12 13:49:46
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\newspaper\signedDraft\signedDraftRouter.js
 * @Description: 
 */
'use strict';
angular.module('newspaperSignedDraftRouterModule', [])
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('front.editctr.newspaper.signedDraft', {
            url: '/signedDraft?paperid&banmianid&starttime&untiltime&dieciid',
            views: {
                'main@front.editctr': {
                    templateUrl: './editingCenter/newspaper/signedDraft/signedDraft_tpl.html',
                    controller: 'newspaperSignedDraftCtrl'
                }
            }
        });
    }]);
